const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8502/api';

export function pushSupporte() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function estInstallee() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export function permission() {
  return pushSupporte() ? Notification.permission : 'unsupported';
}

function b64ToUint8(base64) {
  const pad = '='.repeat((4 - base64.length % 4) % 4);
  const b64 = (base64 + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(b64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

function nomAppareil() {
  const ua = navigator.userAgent;
  if (/iPhone/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua)) return 'iPad';
  if (/Android/.test(ua)) return 'Android';
  if (/Mac/.test(ua)) return 'Mac';
  if (/Windows/.test(ua)) return 'Windows';
  return 'Appareil';
}

export async function enregistrerSW() {
  if (!('serviceWorker' in navigator)) return null;
  try { return await navigator.serviceWorker.register('/sw.js'); }
  catch { return null; }
}

export async function activerNotifications() {
  if (!pushSupporte()) throw new Error('Notifications non supportées sur cet appareil');

  const token = localStorage.getItem('handball_token');
  if (!token) throw new Error('Connecte-toi d\'abord');

  const r = await fetch(`${API_URL}/push/cle`);
  const { cle, actif } = await r.json();
  if (!actif || !cle) throw new Error('Notifications non configurées sur le serveur');

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Tu as refusé les notifications');

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToUint8(cle)
    });
  }

  const j = sub.toJSON();
  const res = await fetch(`${API_URL}/push/abonner`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ endpoint: j.endpoint, keys: j.keys, appareil: nomAppareil() })
  });
  if (!res.ok) throw new Error('Enregistrement impossible');
  return true;
}

export async function desactiverNotifications() {
  const token = localStorage.getItem('handball_token');
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return true;
  await fetch(`${API_URL}/push/desabonner`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ endpoint: sub.endpoint })
  }).catch(()=>{});
  await sub.unsubscribe();
  return true;
}

export async function estAbonne() {
  if (!pushSupporte() || Notification.permission !== 'granted') return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    return !!(await reg.pushManager.getSubscription());
  } catch { return false; }
}

export async function testerNotification() {
  const token = localStorage.getItem('handball_token');
  const res = await fetch(`${API_URL}/push/test`, {
    method: 'POST', headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) { const e = await res.json().catch(()=>({})); throw new Error(e.error || 'Échec'); }
  return true;
}
